import { render, staticRenderFns } from "./customReadings.vue?vue&type=template&id=4c343ffa"
import script from "./customReadings.ts?vue&type=script&lang=js&external"
export * from "./customReadings.ts?vue&type=script&lang=js&external"
import style0 from "./customReadings.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports